import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation deleteDirectory($id: Int) {
  deleteDirectory(id: $id) {
    id
  }
}`;

function deleteDirectory(id) {
  return apollo.client.mutate({
    mutation,
    variables: { id },
  }).then((res) => res.data.deleteDirectory);
}

export default deleteDirectory;
